import React, { useEffect, useState } from "react";
import DeleteModal from "./DeleteModal";
import { useDispatch } from "react-redux";
import {
  getWinnerList,
  publishWinnerList,
} from "../../../features/slices/challanges";
import { useLocation, useNavigate } from "react-router-dom";
import CommonPagination from "../../CommonPagination";
import { useSelector } from "react-redux";
import TableSkeleton from "../../TableSkeleton";
import { toastService } from "../../../utils/toastify";
const initialState = {
  deleteModal: false,
};
const AddWinnerList = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [deleteModalData, setDeleteModalData] = useState("");
  const [page, setPage] = useState(1);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  const { deleteModal } = iState;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();

  useEffect(() => {
    dispatch(getWinnerList({ challengeId: state, page }));
  }, [page]);
  const { winnerList, loading } = useSelector((state) => {
    return state.challenges;
  });
  const handlePublish = () => {
    dispatch(publishWinnerList({ challengeId: state })).then((data) => {
      if (data?.payload?.code == 200) {
        toastService.success("WinnerList publish successfully");
        navigate("/challenges");
      } else {
        toastService.error("WinnerList publish failed");
      }
    });
  };
  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="TableList">
              <table className="table-hover">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Student Id</th>
                    <th>Student Name</th>
                    <th>Rank &amp; Points</th>
                    <th>Remove From List</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <TableSkeleton />
                  ) : (
                    winnerList?.result?.[0]?.paginationData?.map((res, i) => {
                      return (
                        <tr key={res?._id}>
                          <td>{i + 1}</td>
                          <td>{res?.studentData?.user_number}</td>
                          <td>{res?.studentData?.fullName}</td>
                          <td>
                            <strong>{res?.rank || "N/A"} Rank,</strong>{" "}
                            {res?.studentData?.totalPoints} Points
                          </td>
                          <td>
                            <div className="Actions">
                              <a
                                className="Delete"
                                onClick={() => {
                                  setUpdateState((prev) => ({
                                    ...prev,
                                    deleteModal: true,
                                  }));
                                  setDeleteModalData(res);
                                }}
                              >
                                <i className="fa-regular fa-trash-can" />
                              </a>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
            <div className="Pagination">
              <p>
                Showing {(page - 1) * 10 + 1} to{" "}
                {winnerList?.result?.[0]?.paginationData?.length +
                  (page - 1) * 10}{" "}
                of {winnerList?.result?.[0]?.totalCount?.[0]?.count} results
              </p>
              <div className="PaginationRight">
                {winnerList?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                  <CommonPagination
                    activePage={page}
                    itemsCountPerPage={10}
                    totalItemsCount={
                      winnerList?.result?.[0]?.totalCount?.[0]?.count || 0
                    }
                    pageRangeDisplayed={4}
                    onChange={handlePageChange}
                    itemClass="page-item"
                    linkClass="page-link"
                  />
                )}
              </div>
            </div>
          </div>
          <button className="Button" onClick={handlePublish}>
            Publish
          </button>
        </div>
      </div>
      {deleteModal && (
        <DeleteModal
          setUpdateState={setUpdateState}
          deleteModalData={deleteModalData}
        />
      )}
    </>
  );
};

export default AddWinnerList;
